import React from 'react'

function BannerBreadCrumb() {
   return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">Advertising Banners</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="/Admin" className="breadcrumb-link">Dashboard</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Advertising Banners
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default BannerBreadCrumb;